import { ModelHelper } from '../classes/model-helper';
import { UserRole } from '../enums/user-role.enum';
import { Workflow } from './workflow.model';

export class Role {
	name: UserRole;
	workflows: Workflow[];

	/**
	 * Constructor
	 */
	constructor() {}

	/**
	 *
	 *
	 * Static mapping function
	 *
	 *
	 *
	 * @param data
	 * @param item
	 * @returns Role
	 */
	static map(data: any, item: Role = new Role()): Role {
		return item.map(data);
	}

	/**
	 *
	 *
	 * Non static mapping function
	 *
	 *
	 *
	 * @param data
	 * @return Role
	 */
	public map(data: any): Role {
		ModelHelper.map(data, this, 'name');
		ModelHelper.map(data, this, 'workflows', Workflow);

		return this;
	}
}
